import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VDataTable,{attrs:{"headers":_vm.headers,"items":_vm.userList,"show-expand":"","loading":_vm.loading},scopedSlots:_vm._u([{key:`item.data-table-expand`,fn:function({ item }){return [_c(VIcon,{on:{"click":function($event){return _vm.editUser(item)}}},[_vm._v(" mdi-pencil")])]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }